import { Component, OnInit } from '@angular/core';
import { PerfilesUsuarioService} from '../servicios/perfiles-usuario.service';
//import {SharedModule} from '../shared/shared.module';
import { FormsModule } from '@angular/forms'; // Para [(ngModel)]
import { DropdownModule } from 'primeng/dropdown'; // Para <p-dropdown>
import { NbIconModule } from '@nebular/theme'; // Para <nb-icon>
import { CommonModule } from '@angular/common';
//import { SpinnerComponent } from '../spinner/spinner.component';
import { NbCardModule } from '@nebular/theme';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AngularSlickgridModule } from 'angular-slickgrid';
import { NbTabsetModule } from '@nebular/theme';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; // necesario para el datepicker
import { NbSelectModule } from '@nebular/theme';
import { NbTreeGridModule } from '@nebular/theme';
import { MultiSelectModule } from 'primeng/multiselect';
import { MatIconModule } from '@angular/material/icon';
@Component({
    selector: 'app-perfiles-usuario',
    templateUrl: './perfiles-usuario.component.html',
    styleUrls: ['./perfiles-usuario.component.css'],
    standalone: true,
    imports: [FormsModule, MatIconModule, CommonModule, NbCardModule, NbIconModule, DropdownModule, MatCardModule, MatFormFieldModule, MatInputModule, AngularSlickgridModule, NbTabsetModule, MatDatepickerModule, MatNativeDateModule, NbSelectModule, NbTreeGridModule, MultiSelectModule],
})
export class PerfilesUsuarioComponent implements OnInit {

  perfilesUsuarios;

  constructor(private PerfilesUsuarioService: PerfilesUsuarioService) { }

  ngOnInit(): void {
  }

  consultarOrigen() {
    this.PerfilesUsuarioService.getPerfilUsuario().subscribe(
      data => {
        this.perfilesUsuarios = this.insertarPerfilesUsuario(data);

      });
  }

  insertarPerfilesUsuario(armarPerfilUsuario) {
    let Usuarios: Array<any> = [];
    armarPerfilUsuario.content.forEach(element => {
      Usuarios.push({
        label: element.descripcion,
        value: element.id,
      });
    })
    return Usuarios;
  };

}
